import React, { Component } from 'react';
import './App.css';
import Weather from './components/Weather.jsx';

class App extends Component {
  render() {
    return (
      <div>
        <Weather />
      </div>
    );
  }
}

export default App;
